/**
 * Digit-grouped money inputs.
 *
 * Every field where a person types a price shows thousand groups while
 * typing ("60 000", not "60000"), the same way formatPrice renders them.
 * That needs type="text" + inputMode="numeric": a native number input
 * rejects the spaces. Keep the raw digits in state, format on render.
 */

export const GROUP_SEP = " ";

/** Strip everything but digits, drop leading zeros, cap the length. */
export function digitsOnly(raw: string, maxDigits = 9): string {
  return raw.replace(/\D/g, "").replace(/^0+(?=\d)/, "").slice(0, maxDigits);
}

/** "60000" | 60000 -> "60 000". Empty for empty/null input. */
export function groupDigits(value: string | number | null | undefined): string {
  if (value == null || value === "") return "";
  const digits = String(value).replace(/\D/g, "");
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, GROUP_SEP);
}

/** Grouped or plain text -> positive integer, undefined when empty/zero. */
export function parseGrouped(raw: string): number | undefined {
  const digits = digitsOnly(raw);
  if (!digits) return undefined;
  const n = parseInt(digits, 10);
  return Number.isFinite(n) && n > 0 ? n : undefined;
}
